import React, { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";

import Layout from "../../../component/Layout/Layout"
import Card from "../../../component/Layout/theme/card";
import PageChange from "../../../component/pageChange";
import { Input } from "../../../component/form/input";
import LogOut from "../../../component/dashboard/user/logout/logout";

function EditProject() {
    const params = useParams();
    var { t } = useTranslation()
    const { login, token } = useSelector((item) => item.user)
    const [isDataLoad, setIsDataLoad] = useState(false);
    const [data, setData] = useState(null);

    const [site, setSite] = useState("")
    const [hint, setHint] = useState("")
    const [instagramUsername, setInstagramUsername] = useState("")
    const [call, setCall] = useState("")
    const [password, setPassword] = useState("")
    const [limitedView, setLimitedView] = useState(0)


    useEffect(() => {
        if (!login) {
            window.location.href = '/auth'
        } else {
            if (params.id != "null") {
                getAugmentedReality(params.id)
            } else {
                window.location.href = '/projects'
            }
        }
    }, [])


    const axiosInstance = axios.create({
        baseURL: `${process.env.REACT_APP_SERVER}`,
        timeout: 3000000 // only wait
    });

    async function getAugmentedReality(id) {
        await fetch(`${process.env.REACT_APP_SERVER}/api/nft/${id}`, {
            method: "GET",
            headers: {
                Authorization: "ArNew " + token,
            },
        }).then((res) => {
            res
                .json()
                .then((result) => {
                    if (!result.data) {
                        LogOut();
                        toast.error("شما دسترسی ندارید");
                        window.location.href = '/login';
                    }
                    if (result.status === "success") {
                        setIsDataLoad(true)
                        setData(result.data)
                        setSite(result.data.site)
                        setHint(result.data.hint)
                        setInstagramUsername(result.data.instagram)
                        setCall(result.data.call)
                        setLimitedView(result.data.limited_view ? result.data.limited_view : 0)
                        document.title = `ویرایش پروژه "${result.data.name}"`
                    } else {
                        toast.error(result.msg);
                        LogOut();
                        window.location.href = '/login';
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        });
    }

    console.log(data, "sad");

    return (
        <>
            <Layout />
            <Card>
                {isDataLoad ? (

                    <div className="p-5 mb-24 bg-white rounded-lg shadow-md h-[700px]">




                        <h1 className="font-extrabold text-xl text-start text-black mt-8 mx-5">{`ویرایش پروژه "${data.name}"`}</h1>

                        {data.types == "MARKER" && (
                            <>
                                <h4 className="font-normal text-lg text-start text-gray-600 mx-5 my-3">
                                    - شما می توانید برای محتوای خود گزینه هایی را تعریف کنید که مخاطب تعامل بهتری را با شما داشته باشد.
                                </h4>

                                <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-2">
                                    <div className="relative mt-2 ">
                                        <Input
                                            placeholder={"لینک سایت"}
                                            type="text"
                                            id={"site"}
                                            name={"site"}
                                            autoComplete={"off"}
                                            requiredir={true}
                                            defaultValue={site}
                                            onChange={(e) => {
                                                setSite(e.target.value);
                                            }}
                                        />
                                    </div>
                                    <div className="relative mt-2 ">
                                        <Input
                                            placeholder={"تور راهنما"}
                                            type="text"
                                            id={"hint"}
                                            name={"hint"}
                                            autoComplete={"off"}
                                            requiredir={true}
                                            defaultValue={hint}
                                            onChange={(e) => {
                                                setHint(e.target.value);
                                            }}
                                        />
                                    </div>
                                    <div className="relative mt-2 ">
                                        <Input
                                            placeholder={"نام کاربری اینستاگرام (بدون نشانه @ وارد کنید"}
                                            type="text"
                                            id={"instagram"}
                                            name={"instagram"}
                                            autoComplete={"off"}
                                            requiredir={true}
                                            defaultValue={instagramUsername}
                                            onChange={(e) => {
                                                setInstagramUsername(e.target.value);
                                            }}
                                        />
                                    </div>
                                    <div className="relative mt-2 ">
                                        <Input
                                            placeholder={"شماره تماس"}
                                            type="text"
                                            id={"call"}
                                            name={"call"}
                                            autoComplete={"off"}
                                            requiredir={true}
                                            defaultValue={call}
                                            onChange={(e) => {
                                                setCall(e.target.value);
                                            }}
                                        />
                                    </div>
                                </div>
                            </>
                        )}


                        <h4 className="font-normal text-lg text-start text-gray-600 mx-5 my-3">
                            - در این بخش می توانید محدودیت بازدید تعریف کنید که بعد از اتمام محدودیت بازدید پروژه غیرفعال خواهد شد.
                        </h4>
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-2">
                            <div className="relative mt-2 ">
                                <Input
                                    placeholder={"محدودیت بازدید (صفر به عنوان نامحدود می باشد)"}
                                    type="number"
                                    id={"limited_view"}
                                    name={"limited_view"}
                                    autoComplete={"off"}
                                    requiredir={true}
                                    defaultValue={limitedView}
                                    onChange={(e) => {
                                        if (e.target.value < 0) {
                                            e.target.value = 0
                                        }
                                        setLimitedView(e.target.value);
                                    }}
                                />
                            </div>
                        </div>

                        <h4 className="font-normal text-lg text-start text-gray-600 mx-5 my-3">
                            - در این بخش می توانید رمز عبور تعیین کنید تا فقط با رمز عبور قابل بازگشایی فایل باشد.
                            <br />
                            - <span className="text-base">اگر رمز عبور نمیخواهید این قسمت را خالی باقی بزارید</span>
                        </h4>
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-2">
                            <div className="relative mt-2 ">
                                <Input
                                    placeholder={"رمز عبور خود را وارد کنید"}
                                    type="string"
                                    id={"password"}
                                    name={"password"}
                                    autoComplete={"off"}
                                    requiredir={true}
                                    defaultValue={password}
                                    onChange={(e) => {
                                        if (e.target.value < 0) {
                                            e.target.value = 0
                                        }
                                        setPassword(e.target.value);
                                    }}
                                />
                            </div>
                        </div>


                    </div >
                ) : (
                    <PageChange />
                )}

            </Card >

        </>
    )
}

export default EditProject